import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UiService {
  private _headerOpened: BehaviorSubject<boolean>;
  private _menuOpened: BehaviorSubject<boolean>;
  private _searchText: BehaviorSubject<string>;

  constructor() {
    this._headerOpened = new BehaviorSubject<boolean>(false);
    this._menuOpened = new BehaviorSubject<boolean>(false);
    this._searchText = new BehaviorSubject<string>('');
  }

  get headerOpened(): Observable<boolean> {
    return this._headerOpened.asObservable();
  }

  get menuOpened(): Observable<boolean> {
    return this._menuOpened.asObservable();
  }

  get searchText(): Observable<string> {
    return this._searchText.asObservable();
  }

  menuChanged(opened: boolean): void {
    this._menuOpened.next(opened);
  }

  headerChanged(opened: boolean): void {
    this._headerOpened.next(opened);
  }

  searchTextChanged(text: string): void {
    this._searchText.next(text);
  }
}
